import DocumentRequestsAPI from './documentRequests';

// Project-scoped document-request checklist singleton.
export default new DocumentRequestsAPI('projects');
